import Colors from "Common/colors";
import { makeStyles } from "@material-ui/core";

export const stylesProgressSpinner = makeStyles({
    color: {
        color: Colors.black
    }
});